import React, { useState, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Avatar from 'shared/components/avatar/Avatar';
import { messageDate } from 'utils/date';

const ClientSideList = ({ setActiveChat, activeChat, filteredChats }) => {
  const [sortedChats, setSorted] = useState(null);

  useEffect(() => {
    setSorted(
      filteredChats.sort((a, b) => {
        var aTimestamp = a.channel.lastMessageObj.timestamp;
        var bTimestamp = b.channel.lastMessageObj.timestamp;
        return aTimestamp < bTimestamp ? 1 : aTimestamp > bTimestamp ? -1 : 0;
      })
    );
  }, [filteredChats]);

  useEffect(() => {
    !activeChat && sortedChats && setActiveChat(sortedChats[0].client.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedChats]);

  return (
    <div className="client-list-container">
      <Scrollbars autoHide={true}>
        <ul className="client-list">
          {sortedChats &&
            sortedChats.map((chat, i) => {
              let consumedIndex = chat.channel.lastConsumedMessageIndex;
              let lastIndex = chat.channel.lastMessageObj.index;
              let unreadsCount =
                consumedIndex === null
                  ? lastIndex + 1
                  : lastIndex - consumedIndex;
              return (
                <li
                  key={i}
                  className={`${
                    activeChat?.client.id === chat.client.id
                      ? 'active'
                      : unreadsCount
                      ? 'unread'
                      : ''
                  }`}
                  onClick={() => setActiveChat(chat.client.id)}
                >
                  <Avatar
                    src={chat.client?.photo || ''}
                    width="32"
                    height="32"
                    name={`${chat.client?.first_name} ${chat.client?.last_name}`}
                    firstLetters={`${chat.client?.first_name[0].toUpperCase()}${chat.client?.last_name[0].toUpperCase()}`}
                    url={`/messages?client=${chat.client.id}`}
                    text={chat.channel?.lastMessageObj?.body}
                  />
                  {unreadsCount > 0 && (
                    <div className="unread">{unreadsCount}</div>
                  )}
                  <span className="msg-time">
                    {messageDate(chat.channel.lastMessageObj?.timestamp)}
                  </span>
                </li>
              );
            })}
        </ul>
      </Scrollbars>
    </div>
  );
};

export default ClientSideList;
